import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { default as actionStop } from '../stop.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: () => {
    stop()
  }
})

export const stop = () => {
  actionStop()
}

export default button => {
  onClick.listen(button)
}
